export default __webpack_public_path__ + "static/media/CGlearn.4c164c01.png";